/* ============================================================
   BROMOTORS — Cart Free-Shipping Jackpot Detector
   Observe la progress bar et ajoute .bro-fs-jackpot
   quand value >= max (livraison gratuite atteinte)
   ============================================================ */
(function() {
  function checkJackpot() {
    var fs = document.querySelector('#cart-drawer .free-shipping');
    if (!fs) return;
    var bar = fs.querySelector('.free-shipping__progress-bar');
    if (!bar) return;

    var val = parseFloat(bar.value) || 0;
    var max = parseFloat(bar.max) || 100;

    if (val >= max) {
      if (!fs.classList.contains('bro-fs-jackpot')) {
        fs.classList.add('bro-fs-jackpot');
      }
    } else {
      fs.classList.remove('bro-fs-jackpot');
    }
  }

  /* Observer les changements sur la progress bar */
  function initObserver() {
    var fs = document.querySelector('#cart-drawer .free-shipping');
    if (!fs) {
      /* Le drawer n'est peut-être pas encore dans le DOM, réessayer */
      setTimeout(initObserver, 500);
      return;
    }

    var bar = fs.querySelector('.free-shipping__progress-bar');
    if (!bar) return;

    /* Check initial */
    checkJackpot();

    /* Observer les attributs de la progress bar (value change) */
    var observer = new MutationObserver(function() {
      checkJackpot();
    });

    observer.observe(bar, {
      attributes: true,
      attributeFilter: ['value']
    });

    /* Observer aussi les changements dans le conteneur free-shipping
       (Broadcast peut remplacer le contenu via AJAX) */
    var parentObserver = new MutationObserver(function() {
      checkJackpot();
    });

    parentObserver.observe(fs, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  /* Lancer après le DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }

  /* Aussi relancer quand le drawer s'ouvre (Broadcast peut recalculer) */
  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle) {
      setTimeout(checkJackpot, 300);
      setTimeout(checkJackpot, 800);
    }
  });

  /* Écouter les événements cart update de Broadcast */
  document.addEventListener('cart:updated', checkJackpot);
  document.addEventListener('ajaxProduct:added', function() {
    setTimeout(checkJackpot, 500);
  });
})();
